import script from "./TeacherCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherCourse.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherCourse.vue?vue&type=style&index=1&id=ef6a4ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef6a4ebc"]])

export default __exports__